export const BACKUP_CODES_TEST_IDS = {
  codeValue: 'backup-codes-code-value',
  doneButton: 'backup-codes-done-button',
  downloadButton: 'backup-codes-download-button',
  generateButton: 'backup-codes-generate-button',
  primaryActionButton: 'backup-codes-primary-action-button',
  printButton: 'backup-codes-print-button',
} as const;
